// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___KBrjB","container":"container___nmdsS","text_container":"text_container___t_TIx","img_container":"img_container___oaw1F","img":"img___BxC1u"};